<template>
  <div>

    <z-centralized-toolbar>
      <!-- <v-toolbar-items> -->
        <v-btn text rounded color="primary" :to="{name: 'VendedoresLista'}" exact>
          <v-icon left>mdi-arrow-left</v-icon>
          Voltar
        </v-btn>
      <!-- </v-toolbar-items> -->

      <template v-slot:actions>
        <v-btn
          rounded
          text
          :disabled="salvando"
          @click="$router.push({name: 'VendedoresLista'})"
        >Cancelar</v-btn>
        <v-btn
          depressed
          rounded
          color="primary"
          :loading="salvando"
          :disabled="!form_valido"
          @click="confirmar"
          >Salvar</v-btn>
      </template>
    </z-centralized-toolbar>

    <z-container v-if="!$store.state.loading">
      <v-form ref="form" v-model="form_valido" lazy-validation>
      <!-- <h3 class="headline mb-3">{{ titulo }} Vendedor</h3> -->

        <v-card class="mb-3">
        <v-card-title class="text-subtitle-2">
          Dados do Vendedor
        </v-card-title>
        <v-divider></v-divider>

          <v-card-text>
            <v-row dense>
              <v-col sm="7">
                <v-text-field
                  label="Nome"
                  v-model="vendedor.nome"
                  autofocus
                  filled
                  dense
                  :rules="regras.nome"
                ></v-text-field>
              </v-col>
              <v-col sm="3">
                <z-cpf-cnpj
                  v-model="vendedor.cpfcnpj"
                  label="CPF/CNPJ"
                  filled
                  dense
                ></z-cpf-cnpj>
              </v-col>
              <v-col sm="2">
                <v-text-field
                  v-model="vendedor.rg_inscricao"
                  label="RG/Inscrição"
                  filled
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-card class="mb-3">
          <v-card-title class="text-subtitle-2">
            Endereçamento
          </v-card-title>
          <v-divider></v-divider>

          <v-card-text>
            <v-row dense>
              <v-col sm="2">
                <z-cep
                  v-model="vendedor.cep"
                  buscarcep
                  @resultado="preencherEndereco"
                ></z-cep>
              </v-col>
              <v-col sm="8">
                <v-text-field
                  v-model="vendedor.endereco"
                  label="Endereço"
                  filled
                  dense
                  @input="(value) => (vendedor.endereco = value.toUpperCase())"
                ></v-text-field>
              </v-col>
              <v-col sm="2">
                <v-text-field
                  v-model="vendedor.numero"
                  ref="numero"
                  label="Número"
                  filled
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col sm="5">
                <v-text-field
                  v-model="vendedor.bairro"
                  label="Bairro"
                  filled
                  dense
                  @input="(value) => (vendedor.bairro = value.toUpperCase())"
                ></v-text-field>
              </v-col>
              <v-col sm="5">
                <v-text-field
                  v-model="vendedor.cidade"
                  label="Cidade"
                  filled
                  dense
                  @input="(value) => (vendedor.cidade = value.toUpperCase())"
                ></v-text-field>
              </v-col>
              <v-col sm="2">
                <v-select
                  v-model="vendedor.estado"
                  label="Estado"
                  filled
                  dense
                  :items="$globals.ESTADOS"
                ></v-select>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col sm="12">
                <v-text-field
                  v-model="vendedor.complemento"
                  label="Complemento"
                  filled
                  dense
                  @input="(value) => (vendedor.complemento = value.toUpperCase())"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>


        <v-card class="mb-3">
          <v-card-title class="text-subtitle-2">
            Contato
          </v-card-title>
          <v-divider></v-divider>

          <v-card-text>
            <v-row dense>
              <v-col sm="3">
                <v-text-field
                  v-model="vendedor.telefone"
                  v-mask="$globals.TELEFONE_MASK"
                  label="Telefone"
                  filled
                  dense
                ></v-text-field>
              </v-col>
              <v-col sm="3">
                <v-text-field
                  v-model="vendedor.celular"
                  v-mask="$globals.CELULAR_MASK"
                  label="Celular"
                  filled
                  dense
                ></v-text-field>
              </v-col>
              <v-col sm="6">
                <v-text-field
                  v-model="vendedor.email"
                  label="Email"
                  required
                  filled
                  dense
                  :rules="regras.email"
                  @input="(value) => (vendedor.email = value.toLowerCase())"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        
        <v-card class="mb-3">
          <v-card-title class="text-subtitle-2">
            Venda
          </v-card-title>
          <v-divider></v-divider>

          <v-card-text>
            <v-row dense>
              <v-col sm="3">
                <z-campo-valor
                  v-model="vendedor.comissao"
                  label="Comissão"
                  suffix="%"
                  filled
                  dense
                ></z-campo-valor>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-card>
          <v-card-title class="text-subtitle-2">
            Observações
          </v-card-title>
          <v-divider></v-divider>

          <v-card-text>
            <v-row dense>
              <v-col sm="12">
                <v-textarea
                  v-model="vendedor.observacoes"
                  label="Observações"
                  filled
                  dense
                ></v-textarea>
              </v-col>
            </v-row>
          </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-switch
            v-if="$route.meta.editando"
            class="my-0"
            color="primary"
            label="Ativo"
            v-model="vendedor.ativo"
            hide-details
          ></v-switch>
        </v-card-actions>
        </v-card>
      </v-form>

    </z-container>
  </div>
</template>

<script>
import { mapActions, mapMutations } from "vuex";
export default {
  name: "vendedores-form",
  data() {
    return {
      vendedor: {
        estado: "PE",
      },
      salvando: false,
      regras: {},
      tab: "",
      form_valido: false,
      regras: {
        nome: [(v) => !!v || "É necessário preencher a nome do vendedor"],
      },
    };
  },

  beforeRouteLeave(to, from, next) {
    this.UNSET_VENDEDOR();
    next();
  },

  async mounted() {
    this.setTitulo(this.titulo);
    if (this.$route.name == "VendedoresEditar") {
      if (!this.$store.state.vendedores.vendedor) {
        if (this.$route.params.id) {
          await this.abrir(this.$route.params.id);
        }
      }
      this.vendedor = this.clone(this.$store.state.vendedores.vendedor);
    }
  },

  methods: {
    ...mapMutations(["setTitulo"]),
    ...mapMutations("vendedores", ["UNSET_VENDEDOR"]),
    ...mapActions("vendedores", ["abrir", "atualizar", "salvar"]),

    async confirmar() {
      try {
        this.salvando = true;

        if (this.$route.params.id) {
          await this.atualizar(this.vendedor);
        } else {
          await this.salvar(this.vendedor);
        }

        this.$router.push({ path: "/cadastros/vendedores" });
        this.$eventbus.notificar("Vendedor salvo com sucesso");
      } catch (error) {
        this.$eventbus.erro(
          "Não foi possível salvar este Vendedor. Verifique os dados do vendedor e tente novamente.",
          error
        );
      } finally {
        this.salvando = false;
      }
    },

    preencherEndereco(endereco) {
      if (endereco.erro) {
        this.vendedor.endereco = "";
        this.vendedor.bairro = "";
        this.vendedor.cidade = "";
        this.vendedor.estado = "";
        // this.vendedor.ibge  = '';
      } else {
        this.vendedor.endereco = endereco.logradouro.toUpperCase();
        this.vendedor.bairro = endereco.bairro.toUpperCase();
        this.vendedor.cidade = endereco.localidade.toUpperCase();
        this.vendedor.estado = endereco.uf.toUpperCase();
        // this.vendedor.ibge  = endereco.ibge;
        this.$refs.numero.focus();
      }
    },
  },

  computed: {
    titulo() {
      let titulo = this.$route.meta.editando ? "Editar" : "Adicionar";
      return titulo + " " + "Vendedor";
    },
  },
};
</script>

<style scoped>
/* .container.grid-list-md .layout .flex{
    padding-top: 0px;
    padding-right: 4px;
    padding-bottom: 0px;
    padding-left: 4px;
} */
</style>
